export default __webpack_public_path__ + "static/media/on_time_report.922a2f23.svg";